import {Property} from '@deviceinsight/ng-ui-api-client';
import {getAxios} from '@deviceinsight/ng-ui-api-client';

import {displayErrorMessage} from './apiUtils';

export const getAllAssetProperties = (): Promise<Array<Property>> => {
	return getAxios()
		.get(`/v2/properties?entityTarget=ASSET&size=2000`)
		.then(({data: {content}}) => content)
		.catch((e) => displayErrorMessage(e, 'Asset'));
};
